<template>
  <div class="listTest" ref="element">
    <div class="search flex">
      <div class="seaicon">
        <img src="../../assets/icon/搜索@3x.png" height="20" width="20" />
      </div>
      <el-input @input="search" v-model="stutitle" class="seasubfix"></el-input>
    </div>
    <div class="jstudent" v-if="loading">
      <i class="eliwise-loading"></i>加载中请稍后...
    </div>
    <list
      v-else
      ref="list"
      @next="getNext"
      class="jstudent"
      :data="list"
      :next="has_next"
      v-slot="{ item, index }"
    >
      <div
        @click="getstu1(index)"
        :class="{ changeStyle: changeSelectStyle === index }"
        class="jstunum"
        :key="index"
      >
        <div class="studentname">{{ item.id }}.{{ item.name }}</div>
        <div class="touimg">
          <div class="circle" :class="getnumber(item.number)">
            {{ item.number }}
          </div>
        </div>
      </div>
    </list>
  </div>
</template>

<script>
import axios from '../axios'
import list from './list'
import { debounce } from 'lodash'

export default {
  name: 'assistList',
  components: {
    list
  },
  data () {
    return {
      page: 1,
      has_next: true,
      stutitle: '',
      list: [],
      changeSelectStyle: 0,
      type: '',
      loading: false
    }
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.getteacher()
  },
  methods: {
    async getNext () {
      await Promise.all([
        axios
          .get(this.url, {
            params: {
              name: this.stutitle,
              page: this.page
            }
          })
          .then(response => {
            this.list.push(...response.data.teachers)
            this.has_next = response.data.has_next
          })
      ])
      this.page++
    },
    async getteacher () {
      await Promise.all([
        axios
          .get(this.url, {
            params: {
              name: this.stutitle,
              page: this.page
            }
          })
          .then(response => {
            this.list = response.data.assistants
            this.has_next = response.data.has_next
          })
      ])
      if (this.list.length !== 0) {
        this.getfirst()
      }
      this.page++
    },
    getstu1 (index) {
      this.changeSelectStyle = index
      this.$emit('select', this.list[index])
    },
    getfirst () {
      this.changeSelectStyle = 0
      this.$emit('select', this.list[0])
    },
    getnumber (tsnum) {
      if (tsnum > 180) {
        return 's180'
      } else if (tsnum > 100 && tsnum <= 150) {
        return 's6'
      } else if (tsnum > 0 && tsnum <= 100) {
        return 's1'
      } else if (tsnum <= 0) {
        return 's0'
      }
    },
    search: debounce(function () {
      this.resize()
      this.getteacher()
    }, 500),
    resize () {
      this.$refs.list.$el.scrollTop = 0
      this.page = 1
      this.has_next = false
    }
  }
}
</script>
